import actionTypes from 'app/actions/dictionaries/dictionaries.action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PRIVILEGE_DISPLAY_TYPES_DICTIONARY_SUCCESS: {
      return { ...action.displayTypes };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/dictionaries/privilege-display-types-dictionary.js